import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-home-aside',
	templateUrl:'./HomeAsidePage.html',
	styles: [],
	styleUrls:['./HomeAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
],
	standalone:true
})
export class HomeAsidePage
{
}
